import * as types from '../actions/types'
import Immutable from 'immutable'

import {
    isPrimitive,
	detalleparametro
} from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
	parametros: [],
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
})

export default function (state = INITIAL_STATE, action) {
	let index
	switch (action.type) {
		case types.OBTENER_PARAMETROS:
			state = state.set('parametros', Immutable.fromJS(action.payload))
			return state
		case types.OBTENER_PARAMETRO:
			index = state.get('parametros').findIndex(x => x.get(['parametro', 'Id']) === action.payload.id)
			if (index !== -1) {
				state = state.setIn(['parametros', index, 'data'], Immutable.fromJS(action.payload.data[0].data))
			}
			return state
		case types.MODIFICAR_INPUTS_PARAMETROS:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			let path = `${action.payload.path}`.split('.')
			path[path.length - 1] = 'updated'
			state = state.setIn(path, true)
			return state
		case types.ADICIONAR_NUEVO_DETALLE_PARAMETRO:


			const maxRegistro = state.getIn(['parametros', action.payload.parametroId, 'data']).reduce((max, item) => {
				const itemRegistro = item.get('registro')
				return itemRegistro > max ? itemRegistro : max
			}, 0)
			const registro = maxRegistro + 1

			const newItem = detalleparametro(state.getIn(['parametros', action.payload.parametroId, 'columnas']), registro)
			state = state.setIn(['parametros', action.payload.parametroId, 'data'], state.getIn(['parametros', action.payload.parametroId, 'data']).push(Immutable.fromJS(newItem)))
			return state
		case types.CONMUTAR_SELECCION_TODOS_PARAMETROS:
			state.getIn(['parametros', action.payload.parametroIndex, 'data']).forEach((x, n) => {
				state = state.setIn(['parametros', action.payload.parametroIndex, 'data', n, 'Selected'], action.payload.checked)
			})
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PARAMETRO:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/parametros1.js